import React from "react";
import { Droppable } from "react-beautiful-dnd";

import SchedulerColumnWrapper from "../ScheduleBarChart/SchedulerColumnWrapper";
import SchedulerDraggableBar from "./SchedulerDraggableBar";
import { StyledDroppableStack, StyledPlaceholderDiv } from "./styles";

const SchedulerColumn = ({
  week,
  view,
  targetDate,
  isActive,
  placeholderProps,
}) => (
  <SchedulerColumnWrapper column={week} isDragging={isActive}>
    <Droppable droppableId={String(week.id)}>
      {(provided, snapshot) => (
        <StyledDroppableStack
          className="HubDroppable-root"
          ref={provided.innerRef}
          {...provided.droppableProps}
        >
          {week.elements.map((el, idx) => (
            <SchedulerDraggableBar
              key={el.id}
              element={el}
              order={idx}
              isDraggingOver={snapshot.isDraggingOver}
              isActive={isActive}
              view={view}
              targetDate={targetDate}
            />
          ))}
          <div
            className="HubDroppable-placeholder"
            style={StyledPlaceholderDiv({
              placeholderProps,
              disabled:
                placeholderProps?.destinationId !== String(week.id),
            })}
          />
        </StyledDroppableStack>
      )}
    </Droppable>
  </SchedulerColumnWrapper>
);

export default SchedulerColumn;
